import {Component, Renderer2, ElementRef, AfterViewInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {environment} from 'src/environments/environment';
import {DataService} from 'src/app/services/data.service';
import {TrustiiService} from 'src/app/services/trustii.service';
import {ProgressService} from 'src/app/services/progress.service';
import {Chart} from 'chart.js';

@Component({
  selector: 'app-enterprise-insight-details',
  templateUrl: './insight-details.component.html',
  styleUrls: ['./insight-details.component.scss'],
})
export class EnterpriseInsightDetailsComponent implements AfterViewInit {
  devMode: boolean;
  insights = { columns: [], index: [], data: [] };
  inProgress = false;
  predictionFetched = false;
  predictionFailed = false;
  columns = [{ name: '', value: 0 }];
  datasetConfigurationFetch = false;
  changePageInProgress = false;
  page = 0;
  nbPage = 0;
  charts = [];
  loadingMsg = 'Fetching insight details. Please wait....';
  @ViewChild('dashboardChartArea', { static: false })
  private chartDiv: ElementRef;

  constructor(
    private router: Router,
    private dataservice: DataService,
    private trustiiService: TrustiiService,
    private progressService: ProgressService,
    private host: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit() {
    this.devMode = !environment.production;
    this.inProgress = true;
    this.progressService.progressBar.next({
      loading: true,
      message: this.loadingMsg,
      inProgress: this.inProgress,
    });
    this.trustiiService
      .getInsightData(this.dataservice.data.insightId)
      .subscribe(
        (res) => {
          this.predictionFetched = true;
          this.predictionFailed = false;
          this.insights = res;
          this.inProgress = false;
          this.progressService.progressBar.next({
            loading: false,
            message: this.loadingMsg,
            inProgress: this.inProgress,
          });
          this.nbPage = Math.ceil((this.insights.columns.length - 1) / 2);
          this.drawChartJS();
        },
        (err) => {
          this.predictionFetched = true;
          this.predictionFailed = true;
          this.inProgress = false;
          this.progressService.progressBar.next({
            loading: false,
            message: this.loadingMsg,
            inProgress: this.inProgress,
          });
        }
      );
  }

  changePage(page: number = 0) {
    this.page = page;
    this.changePageInProgress = true;
    setTimeout(() => this.drawChartJS(this.page), 1000);
  }

  drawChartJS(page: number = 0) {
    const trustiiColumnName = 'TRUSTii-Prediction';
    let trustiiIndex = 0;
    this.insights.columns.forEach((item, index) => {
      if (trustiiColumnName === item) {
        trustiiIndex = index;
      }
    });

    this.chartDiv.nativeElement.innerHTML = '';
    const columns = this.insights.columns.slice(
      this.page * 2,
      this.page * 2 + 2
    );
    columns.forEach((element, index) => {
      if (element !== trustiiColumnName) {
        const cid = 'canvas' + index;
        this.addCanvas(cid);
        // const data = [];
        let columnIndex = 0;
        this.insights.columns.forEach((insightColumn, i) => {
          if (element === insightColumn) {
            columnIndex = i;
          }
        });

        const data = this.insights.data.map((insight: any) => ({
          x: insight[columnIndex],
          y: insight[trustiiIndex],
        }));

        const item = new Chart(cid, {
          type: 'scatter',
          data: {
            datasets: [
              {
                label: element,
                backgroundColor: 'rgb(255, 99, 132)',
                data,
              },
            ],
          },
          options: {
            scales: {
              xAxes: [
                {
                  type: 'linear',
                  position: 'bottom',
                },
              ],
              yAxes: [
                {
                  scaleLabel: {
                    display: true,
                    labelString: trustiiColumnName,
                  },
                },
              ],
            },
            legend: {
              display: true,
              onClick: () => {
                /* do nothing*/
              },
              labels: {
                fontColor: 'rgb(255, 99, 132)',
              },
            },
          },
        });
        this.charts.push(item);
      }
    });
    this.changePageInProgress = false;
  }

  addCanvas(id) {
    const div = this.renderer.createElement('div');
    div.setAttribute('class', 'col-6 mx-auto  p-2');
    const canvas = this.renderer.createElement('canvas');
    canvas.setAttribute('id', id);
    canvas.setAttribute('class', 'bg-white');
    this.renderer.appendChild(div, canvas);
    this.renderer.appendChild(this.chartDiv.nativeElement, div);
  }

  downloadToCSVFile(e) {
    e.preventDefault();
    this.dataservice.downloadFile(
      this.insights.data,
      this.insights.columns,
      'trustii-predictions-' + Date.now()
    );
  }

  backToInsights() {
    this.router.navigateByUrl('enterprise/insights');
  }
}
